import React from 'react';

export function BarChartVerticalWrapper({ children }) {
    return <div className="bar-chart-vertical" >{children}</div>;
}

